import store from "@/store/index";

export const onlySupplier = ({ to, from, next }) => {
  if (
    store.state.authenticate.userLogin &&
    store.state.authenticate.userLogin?.suppliers?.length &&
    !store.state.authenticate.userLogin?.processors?.length
  ) {
    return next();
  }

  return next({ name: from?.name });
};

export const onlyProcessor = ({ to, from, next }) => {
  if (
    store.state.authenticate.userLogin &&
    store.state.authenticate.userLogin?.processors?.length
  ) {
    return next();
  }

  return next({ name: from?.name });
};

export const onlySupplierProduct = ({ to, from, next }) => {
  if
    // TODO: update when implement api
    (store.state.authenticate.userLogin &&
    store.state.authenticate.userLogin?.ecom_suppliers?.length
  ) {
    return next();
  }

  return next({ name: from?.name });
};
